import { useParams } from "react-router";
import OfficeFrame from "../molecules/OfficeFrame";
import { useEffect } from "react";
import { useOfficeData } from "../api/swr/useOfficeData";
import { CenterSpinner } from "../atoms/spinner";
import NoResult from "~/molecules/NoResult";

const Office = () => {
  const { id } = useParams();

  const { data: officeData, isLoading } = useOfficeData(id);

  useEffect(() => {
    if (!officeData?.faviconUrl) return;

    let prevFavicon: string | undefined;
    let prevViewport: string | undefined;

    const favicon = document.getElementById("favicon") as HTMLAnchorElement;
    if (favicon) {
      prevFavicon = favicon.href;
      favicon.href = officeData.faviconUrl;
    }

    const viewport = document.getElementById("viewport") as HTMLMetaElement;
    if (viewport) {
      prevViewport = viewport.content;
      viewport.content =
        "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no";
    }

    document.title = `${officeData.title} | North House`;

    return () => {
      if (favicon && prevFavicon) {
        favicon.href = prevFavicon;
      }

      if (viewport && prevViewport) {
        viewport.content = prevViewport;
      }
    };
  }, [officeData?.faviconUrl, officeData?.title]);

  if (isLoading) {
    return <CenterSpinner withText />;
  }

  if (officeData === undefined) {
    return <NoResult />;
  }

  return <OfficeFrame officeData={officeData} />;
};

export default Office;
